export type NotificationRedirectResult = {
    target: string | null;
    isExternal: boolean;
};

export const isExternalLink = (link: string): boolean =>
    /^(https?:)?\/\//i.test(link) || link.startsWith("mailto:") || link.startsWith("tel:");

const normalizeTarget = (value: unknown): string | null => {
    if (typeof value !== "string") {
        return null;
    }

    const trimmed = value.trim();
    return trimmed.length > 0 ? trimmed : null;
};

const extractLinkFromPayload = (payload: any): string | null => {
    if (!payload || typeof payload !== "object") {
        return null;
    }

    const candidates = [
        payload.url,
        payload.link,
        payload.href,
        payload.route,
        payload.path,
        payload.target,
    ];

    for (const candidate of candidates) {
        const normalized = normalizeTarget(candidate);
        if (normalized) {
            return normalized;
        }
    }

    const nestedCandidates = [payload.notification, payload.data, payload.payload, payload.item];
    for (const nested of nestedCandidates) {
        const nestedLink = extractLinkFromPayload(nested);
        if (nestedLink) {
            return nestedLink;
        }
    }

    return null;
};

export const resolveNotificationRedirect = (
    payload: unknown,
    fallback: string | null = "/notifications"
): NotificationRedirectResult => {
    const direct = normalizeTarget(payload);
    const resolved = direct ?? extractLinkFromPayload(payload) ?? normalizeTarget(fallback);

    return {
        target: resolved,
        isExternal: resolved ? isExternalLink(resolved) : false,
    };
};
